import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@mui/material';

import { useStyles } from './success-modal.styles';
import { Modal } from '../../../../../common';
import { CreateErrorModalProps } from './success-modal.models';
import { Button } from '../../../../../common/button-new';
import { InternalLinks } from '../../../../../../constants';
import { v2025PP16783 } from '../../../../../../constants/veeva';
import image from '../../../../../../assets/images/kids/success.jpg';
import imageDesk from '../../../../../../assets/images/kids/success-desktop.jpg';

export const SuccessModal = ({ onClose, ...props }: CreateErrorModalProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Modal
      {...props}
      isCloseLight
      topIcon={<div className={classes.image}><img src={isMobile ? image : imageDesk} alt="" /></div>}
      propsPaperStyles={classes.paperStyles}
      veevaNumber={v2025PP16783}
      onClose={onClose}
      content={(
        <>
          <h2 className={classes.title}>
            <FormattedMessage id="createKidsProfile.success.title" />
          </h2>
          <p className={classes.text}>
            {intl.formatMessage(
              { id: 'createKidsProfile.success.text-1' },
              {
                strong: (chunk: ReactNode) => <strong className={classes.strong}>{chunk}</strong>,
                noBreak: <>&nbsp;</>,
                sup: (chunk: ReactNode) => <sup>{chunk}</sup>,
              },
            )}
          </p>
          <p className={classes.text}>
            <FormattedMessage id="createKidsProfile.success.text-2" />
          </p>
          <div className={classes.actions}>
            { /* Don't remove data-testid: it is used by Yandex Metrica. */ }
            <Button style="dark" to={InternalLinks.ecpLocator} testId="get-contact-lenses-link">
              {intl.formatMessage({ id: 'createKidsProfile.success.button-1' }, { noBreak: <>&nbsp;</> })}
            </Button>
            { /* Don't remove data-testid: it is used by Yandex Metrica. */ }
            <Button style="outlined" to={InternalLinks.forKids} testId="kids-profile-myacuvue">
              {intl.formatMessage({ id: 'createKidsProfile.success.button-2' })}
            </Button>
          </div>
        </>
      )}
    >
    </Modal>
  );
};
